// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BaseComponent from "../../../../../engines/components/BaseComponent";
import O1HD from "../../../../../engines/gameEngine";
import TouchCardItemBase from "../common/TouchCardItemBase";
import TouchCardChallengeLayer from "./TouchCardChallengeLayer";

const {ccclass, property} = cc._decorator;

@ccclass
export default class TouchCardChallengeItem extends BaseComponent {

	@property({ type: cc.Node, displayName:'' })
	nodeBlack: cc.Node = null;

	@property({ type: cc.Node, displayName:'' })
	btnClick: cc.Node = null;

    @property(cc.Node)
    cardParent: cc.Node = null;
	// @property({ type: BaseStateSprite, displayName:'' })
	// sprBg: BaseStateSprite = null;

    private itemScirpt: TouchCardItemBase = null;

    private _parent: TouchCardChallengeLayer = null;
    private cardData: number = null;
    // onLoad () {}

    start () {
        this.resetData();
        this.itemScirpt = this.cardParent.getChildByName('TouchCardItemBase').getComponent(TouchCardItemBase);
        this.itemScirpt.setData(this.cardData);
        this.initUI();
    }

    resetData() {
        this.btnClick.active = true;
        this.nodeBlack.active = false;
    }

    setData(
        cardData: number
        , _parent: TouchCardChallengeLayer
    ) {
        this._parent = _parent;
        this.cardData = cardData;
    }

    initUI() {
      
    }

    setValid(enable: boolean) {
        this.btnClick.active = false;
        this.nodeBlack.active = false;
        if (enable) {
            this.btnClick.active = true;
        } else {
            this.nodeBlack.active = true;
        }
    }

    setClickState(enable: boolean) {
        this.btnClick.active = enable;
    }

    getCardData() {
        return this.cardData;
    }

    isEnable() {
        return this.btnClick.active;
    }

    showBgState(bfill: boolean) {
        // this.sprBg.setFill(bfill);
    }

    onClickEnd() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this._parent.showRet(this.cardData);
    }

    // update (dt) {}
}
